/* DUI Window V2
Allows you to create windows, with windowTitle, dimensions, buttons (with labels)	

NEW IN VERSION 2:
	- dynamic settings,
	- dynamic button configuration (allows for any number of buttons)

ROADPLAN V3: 
1.General cleanup, possibly as a jQuery plugin
2. Refactor CSS code to be acessible from CSS


Example:
var importHTML = [];
importHTML.push('<table style="width:100%;">');
importHTML.push('<tr>');
importHTML.push('<td style="width:20%;">');
importHTML.push('<strong>Report:</strong>');
importHTML.push('</td>');
importHTML.push('<td style="width:60%;">');
importHTML.push('<select id="importSlides_select_report" style="width:332px;"></select>');
importHTML.push('</td>');
importHTML.push('<td rowspan="2" style="width:20%;">');
importHTML.push('<p style="border:1px solid #F0C36D;background-color:#F9EDBE;padding:5px;font-size:11px;"><strong>How it works:</strong><br/>This will import and insert slides from other reports after the current slide.</p>');
importHTML.push('</td>');
importHTML.push('</tr>');
importHTML.push('<tr id="importSlides_row_slides" style="display:none">');
importHTML.push('<td>');
importHTML.push('<strong>Slides:</strong>');
importHTML.push('</td>');
importHTML.push('<td>');
importHTML.push('<select id="importSlides_select_slides" style="width:150px;"></select>');
importHTML.push('</td>');
importHTML.push('</tr>');
importHTML.push('</table>');
importHTML = importHTML.join('');


var importWin = new DUIwindow({
	title: 'test',
	width: 600,
	height: 400,
	modal: true,
	preWrapSpace: true,
	buttons: [{
		text: 'OK',
		focused: true,
		onClick: function (evt) {
			alert('Hej');
		}
	},
	{
		text: 'Cancel',
		onClick: function(evt) {
			
		}
	}]
});
*/

window.DUIwindow = function (options) {
    var settings = {
        title: '',
        width: 300,
        height: 200,
        headerHeight: 28,
        buttonsHeight: 34,
        padding: 8,
        cssClass: '',
        backgroundColor: '#eee',
        buttons: [{
            text: '',
            focused: false,
            closeWindow: true,
            onClick: null
        }],
        html: '',
        modal: true,
        preWrapSpace: true,
        afterShow: $.noop
    }

    if (options.buttons.length == 0)
        settings.buttons = [];

    for (var i = 0; i < options.buttons.length; i++) {
        var button = {};
        $.extend(button, settings.buttons[0]);
        $.extend(button, options.buttons[i]);
        options.buttons[i] = button;
    }
    $.extend(true, settings, options);

    function generateID() {
        var newDate = new Date;
        return newDate.getTime();
    }

    var DUIwindowID = 'window_' + generateID();
    this.id = DUIwindowID;
    this.title = settings.title;

    settings.width = parseInt(settings.width, 10);
    settings.height = parseInt(settings.height, 10);
    settings.padding = parseInt(settings.padding, 10);

    // windowHeight + bodyPadding + titleContainer + buttonsContainer
    this.height = parseInt(settings.height + settings.padding + (settings.title !== '' ? settings.headerHeight + 1 : 0) + (settings.buttons.length > 0 ? settings.buttonsHeight + 1 : 0), 10);

    this.bodyHeight = settings.height;
    this.width = settings.width + (settings.padding * 2);
    this.settings = settings;

    var preWrapSpaceString = (settings.preWrapSpace) ? 'white-space: pre-wrap;' : '';

    var winHTML = [];
    if (settings.modal) winHTML.push('<div id="' + DUIwindowID + '_modal" class="DUI-WINDOW-MODAL"></div>');
    winHTML.push('<div id="' + DUIwindowID + '" class="DUI-WINDOW ' + settings.cssClass + '" style="position:fixed;z-index:99999;left:50%;margin-left:-' + parseInt(this.width / 2, 10) + 'px;width:' + this.width + 'px;height:' + this.height + 'px;top:50%;margin-top:-' + parseInt(this.height / 2, 10) + 'px;">');
    winHTML.push('<div class="DUI-WINDOW-HEADER">' + settings.title + '</div>');
    winHTML.push('<div class="DUI-WINDOW-BODY" style="overflow: auto; background-color:' + settings.backgroundColor + ';height:' + this.bodyHeight + 'px;' + preWrapSpaceString + '">');
    winHTML.push(settings.html);
    winHTML.push('</div>');
    if (settings.buttons.length > 0)
        winHTML.push('<div class="DUI-WINDOW-BUTTONS"></div>');
    winHTML.push('</div>');

    $('body').append(winHTML.join(''));

    for (var btnIndex = 0; btnIndex < settings.buttons.length; btnIndex++) {
        var btn = settings.buttons[btnIndex];
        var focused = (btn.focused == true) ? 'focused' : '';

        var buttonEl = document.createElement('INPUT');
        buttonEl.setAttribute((document.all && !document.querySelector ? 'className' : 'class'), 'DUI-BUTTON DUIbutton ' + focused)
        buttonEl.setAttribute('id', DUIwindowID + '_btn' + btnIndex);
        buttonEl.setAttribute('type', 'button');
        buttonEl.setAttribute('value', btn.text);
        buttonEl.onclick = btn.onClick;

        $('#' + DUIwindowID + ' .DUI-WINDOW-BUTTONS').append(buttonEl);
        $('.DUI-WINDOW-BUTTONS > .DUI-BUTTON').css('margin-left', '5px');

        $(document).undelegate('#' + DUIwindowID + '_btn' + btnIndex, 'click');
        $(document).delegate('#' + DUIwindowID + '_btn' + btnIndex, 'click', function (evt) {
            if (evt) evt.stopImmediatePropagation();
            if (btn.closeWindow) {
                $('#' + DUIwindowID).remove();
                $('#' + DUIwindowID + '_modal').remove();
            }
        });

    }

    if ($.isFunction(settings.afterShow)) {
        settings.afterShow.call(this);
    }

    this.Close = function () {
        $('#' + DUIwindowID).remove();
        $('#' + DUIwindowID + '_modal').remove();
    }
};

window.DUIwindow2 = function (options) {
    var settings = {
        title: '',
        width: 300,
        height: 'auto',
        padding: 36,
        cssClass: '',
        topPosition: '',
        forceCenterPosition: false,
        buttons: [{
            text: '',
            focused: false,
            closeWindow: true,
            onClick: null,
            buttonId: null,
            cssClass: 'DUIbutton'
        }],
        html: '',
        modal: true,
        preWrapSpace: true,
        closeButton: true,
        afterShow: $.noop,
        beforeClose: $.noop,
        afterClose: $.noop,
        closeOnParentClick: true
    },
    that = this;

    if (!options.buttons || options.buttons.length === 0) {
        settings.buttons = options.buttons = [];
    }

    for (var i = 0; i < options.buttons.length; i++) {
        var button = {};
        $.extend(button, settings.buttons[0]);
        $.extend(button, options.buttons[i]);
        options.buttons[i] = button;
    }
    $.extend(true, settings, options);

    function generateID() {
        var newDate = new Date;
        return newDate.getTime();
    }

    var DUIwindowID = 'window_' + generateID(),
		preWrapSpaceString = (settings.preWrapSpace) ? 'white-space: pre-wrap;' : '',
		windowWidth = (settings.width === 'auto' ? 'auto' : (parseInt(settings.width, 10) + (settings.padding * 2)) + 'px'),
		contentHeight = (settings.height === 'auto' ? 'auto' : parseInt(settings.height, 10) + 'px'),
        windowOuterCssClass = 'DUI-WINDOW-OUTER ' + (settings.modal ? 'DUI-WINDOW-OVERLAY' : '');

    if (settings.forceCenterPosition)
        windowOuterCssClass += ' DUI-WINDOW-CENTER';
    else
        windowOuterCssClass += (settings.topPosition === '' && self === top ? ' DUI-WINDOW-CENTER' : '');

    this.id = DUIwindowID;

    DUIWindowScrollbar.setScrollbar();
    $(document.body).append(generateWindowHTML).parent().addClass('DUI-WINDOW-LOCK');

    this.windowEl = document.getElementById(DUIwindowID);

	for (var btnIndex = 0; btnIndex < settings.buttons.length; btnIndex++) {
		generateButton(settings.buttons[btnIndex]);
	}

    $(document).bind('keyup.DUI-WINDOW-2', keyupHandler);
    $(this.windowEl).find('.DUI-WINDOW-CLOSE').bind('click', closeWindow);
    if(settings.closeOnParentClick)
        $(this.windowEl).parent().bind('click', function(event) {
            if (event.target === this)
                closeWindow();
        });

    if ($.isFunction(settings.afterShow)) {
        settings.afterShow.call(that);
    }

    function generateWindowHTML() {
        var winHTML = [];
        winHTML.push('<div id="' + DUIwindowID + '_modal" class="' + windowOuterCssClass + '">');
        winHTML.push('<div id="' + DUIwindowID + '" class="DUI-WINDOW-2 ' + settings.cssClass + '" style="width: ' + windowWidth + (settings.topPosition.substr(-2) === 'px' ? '; margin-top: ' + settings.topPosition : '') + '">');


        if (settings.closeButton === true) {
            winHTML.push('<button type="button" class="DUI-WINDOW-CLOSE" title="Close"><svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 6.812l3.565-3.566a.84.84 0 011.189 1.189L9.188 8l3.566 3.565a.84.84 0 01-1.189 1.189L8 9.188l-3.565 3.566a.84.84 0 01-1.189-1.189L6.812 8 3.246 4.435a.84.84 0 011.189-1.189L8 6.812z" fill="currentColor" fill-rule="evenodd"/></svg></button>');
        }
        if (settings.title !== '') winHTML.push('<div class="DUI-WINDOW-HEADER">' + settings.title + '</div>');

        winHTML.push('<div class="DUI-WINDOW-BODY" style="height:' + contentHeight + '; ' + preWrapSpaceString + '">');
        winHTML.push(settings.html);
        winHTML.push('</div>');

        if (settings.buttons.length > 0) winHTML.push('<div class="DUI-WINDOW-BUTTONS"></div>');

        winHTML.push('</div></div>');

        return winHTML.join('');
    }

	function getButtonClassName(btn) {
		return 'DUI-BUTTON ' + (btn.cssClass ? btn.cssClass : 'DUIbutton') + (btn.focused == true ? ' focused' : '');
	}

	function getButtonId(btn) {
		return (btn.buttonId === null) ? DUIwindowID + '_btn' + btnIndex : btn.buttonId;
	}

    function generateButton(btn) {
        var buttonCssClass = getButtonClassName(btn);
        var buttonId = getButtonId(btn);
        var button = document.createElement('INPUT');
        button.setAttribute((document.all && !document.querySelector ? 'className' : 'class'), buttonCssClass);
        button.setAttribute('id', buttonId);
        button.setAttribute('type', 'button');
        button.setAttribute('value', btn.text);
        button.onclick = btn.onClick;

        $(document).delegate('#' + buttonId, 'click.DUI-WINDOW-2', function(evt) {
            if (evt) evt.stopImmediatePropagation();
            if (btn.closeWindow) {
                closeWindow();
            }
        });
        $('#' + DUIwindowID + ' .DUI-WINDOW-BUTTONS').append(button);
    }

	function destroyButton(btn) {
		var buttonId = getButtonId(btn);
		$(document).undelegate('#' + buttonId, 'click.DUI-WINDOW-2');
		$('#' + buttonId).remove();
	}

	function keyupHandler(e) {
        if (e.which === 13 && !e.shiftKey) { $(that.windowEl).find('.DUI-WINDOW-BUTTONS .DUI-BUTTON.focused').click(); } // enter
		if (e.which === 27) { closeWindow(); } // esc
	}

    function closeWindow() {
        if ($.isFunction(settings.beforeClose)) {
            if (settings.beforeClose.call(that) === false)
                return;
        }

        $('#' + DUIwindowID + '_modal').remove();

        if ($('.DUI-WINDOW-OUTER > DUI-WINDOW-2:not(.drilldownStoryTellerWindow)').length === 0) 
            $('.DUI-WINDOW-LOCK').removeClass('DUI-WINDOW-LOCK');

		for (var btnIndex = 0; btnIndex < settings.buttons.length; btnIndex++) {
			destroyButton(settings.buttons[btnIndex]);
		}

        $(document).unbind('keyup.DUI-WINDOW-2', keyupHandler);

        DUIWindowScrollbar.resetScrollbar();

        if ($.isFunction(settings.afterClose)) {
            settings.afterClose.call(that);
        }
    }

    this.Close = closeWindow;
	this.close = closeWindow;
};

window.DUIWindowScrollbar = {
    originalBodyPadding: null,
    scrollbarWidth: 0,

    setScrollbar: function () {
        var bodyPadding;
        var fullWindowWidth = window.innerWidth;
        var bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;

        if (this.scrollbarWidth <= 0 || 
            $(document.documentElement).hasClass('DUISetup-lock') ||
            !bodyIsOverflowing)
                return;

        bodyPadding = parseInt(($(document.body).css('padding-right') || 0));
        this.originalBodyPadding = document.body.style.paddingRight || '';
        
        $(document.body).css('padding-right', bodyPadding + this.scrollbarWidth);
    },

    resetScrollbar: function () {
        if (!$(document.documentElement).hasClass('DUISetup-lock'))
            $(document.body).css('padding-right', this.originalBodyPadding);
    }
};

// get scrollbar width
document.addEventListener('DOMContentLoaded', function() {
    var scrollDiv = document.createElement('div');
    var scrollbarWidth;
    scrollDiv.setAttribute('style', 'position: absolute; top: -9999px; width: 50px; height: 50px; overflow: scroll;');
    document.body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    DUIWindowScrollbar.scrollbarWidth = scrollbarWidth;
});